import { NgModule, Pipe } from '@angular/core';

@Pipe({
    name: 'httpPrefix'
})
export class HttpPrefixPipe {
    transform(href: string) {
        if (href.indexOf('@') > -1) {
            return `mailto:${href}`;
        }
        return href.startsWith('http://') || href.startsWith('https://') ? href : `http://${href}`;
    }
}

@NgModule({
    declarations: [HttpPrefixPipe],
    exports: [HttpPrefixPipe]
})
export class HttpPrefixPipeModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/pipes/httpprefix.pipe/http.prefix.pipe.module.ts